import { render, staticRenderFns } from "./HeaderMenuItem.vue?vue&type=template&id=0a8fba51"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=js"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=js"
import style0 from "./HeaderMenuItem.vue?vue&type=style&index=0&id=0a8fba51&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports